var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplyarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 253,
    viewBox: "0 0 267 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5694 160.411C38.7589 156.942 24.5674 149.033 11.834 143.617C10.5572 143.074 10.3747 141.782 11.6479 141.231C16.9405 138.939 31.2261 133.777 58.4565 112.403",
    stroke: "#5D74F1",
    strokeWidth: 5.39796,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6837 142.164C59.4387 143.033 110.89 109.377 142.771 106.398C167.107 104.123 195.9 127.14 190.272 149.543C184.438 172.769 142.771 186.043 131.341 153.963C119.91 121.884 211.724 107.135 231.266 89.8047",
    stroke: "#5D74F1",
    strokeWidth: 5.39796,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyarrow);
export default __webpack_public_path__ + "static/media/applyarrow.f39e803c20c2a7b0dc6639deba7cb84d.svg";
export { ForwardRef as ReactComponent };